import script from "./TestimonialsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestimonialsSection.vue?vue&type=script&lang=ts&setup=true"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=d3944a7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3944a7e"]])

export default __exports__